import * as Scrivito from "scrivito";

Scrivito.provideComponent(
  "FactWidget",
  Scrivito.connect(({ widget }) => {
    const backgroundImage = widget.get("backgroundImage");
    const icon = widget.get("icon");
    const iconPosition = widget.get("iconPosition");
    const boxStyle = widget.get("boxStyle");
    const destination = widget.get("destination");
    const iconSize = widget.get("iconSize") || "300";
    const iconSizeTablet = widget.get("iconSizeTablet") || "300";
    const iconSizeMobile = widget.get("iconSizeMobile") || "300";

    const classNames = [
      "fact-widget",
      `bg-${boxStyle}`,
      iconPosition === "top" ? "--icon-top" : "--icon-right",
      backgroundImage ? `bg-${boxStyle}-blur --with-image` : "--without-image",
    ];

    const style = backgroundImage && {
      "--blur-strength": "0px",
      "--opacity": "0.7",
      backgroundImage: `url(${Scrivito.urlFor(backgroundImage)})`,
    };

    const content = (
      <div className={classNames.join(" ")} style={style}>
        <div className="fact-widget-content-wrapper">
          <div className="fact-widget-header">
            <Scrivito.ContentTag
              content={widget}
              attribute="value"
              className="fact-widget-value"
            />
            {icon && (
              <i
                className={`fact-widget-icon ${icon} is-${iconSize} is-md-${iconSizeTablet} is-sm-${iconSizeMobile}`}
              />
            )}
          </div>
          <Scrivito.ContentTag
            content={widget}
            attribute="key"
            className="fact-widget-key"
          />

          {destination && (
            <button className="btn bg-white mt-3">
              {destination?.title() || "Mehr Informationen"}
            </button>
          )}
        </div>
      </div>
    );

    return destination ? (
      <Scrivito.LinkTag to={destination} className="text-decoration-none">
        {content}
      </Scrivito.LinkTag>
    ) : (
      content
    );
  })
);
